import { render, staticRenderFns } from "./EleEditableWrapper.vue?vue&type=template&id=0b0422b9&"
import script from "./EleEditableWrapper.vue?vue&type=script&lang=js&"
export * from "./EleEditableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports